module.exports = __webpack_public_path__ + "static/img/3.564d5af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/3.png
// module id = hz6k
// module chunks = 0